/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthedRegisterRouteImport } from './routes/_authed/register'
import { Route as AuthedOpsRouteImport } from './routes/_authed/ops'
import { Route as AuthedOnboardingRouteImport } from './routes/_authed/onboarding'
import { Route as AuthedPortalRouteImport } from './routes/_authed/_portal'
import { Route as AuthedOpsIndexRouteImport } from './routes/_authed/ops/index'
import { Route as AuthedPortalIndexRouteImport } from './routes/_authed/_portal/index'
import { Route as AuthedOpsUsersRouteImport } from './routes/_authed/ops/users'
import { Route as AuthedOpsTransactionsRouteImport } from './routes/_authed/ops/transactions'
import { Route as AuthedOpsRatesRouteImport } from './routes/_authed/ops/rates'
import { Route as AuthedOpsParcelsRouteImport } from './routes/_authed/ops/parcels'
import { Route as AuthedOpsMessagesRouteImport } from './routes/_authed/ops/messages'
import { Route as AuthedOpsAddressesRouteImport } from './routes/_authed/ops/addresses'
import { Route as AuthedOpsAccountRouteImport } from './routes/_authed/ops/account'
import { Route as AuthedPortalMessagesRouteImport } from './routes/_authed/_portal/messages'
import { Route as AuthedPortalHistoryRouteImport } from './routes/_authed/_portal/history'
import { Route as AuthedPortalAddressesRouteImport } from './routes/_authed/_portal/addresses'
import { Route as AuthedPortalAccountRouteImport } from './routes/_authed/_portal/account'
import { Route as AuthedPortalParcelIdRouteImport } from './routes/_authed/_portal/parcel.$id'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRegisterRoute = AuthedRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOpsRoute = AuthedOpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPortalRoute = AuthedPortalRouteImport.update({
  id: '/_portal',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOpsIndexRoute = AuthedOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedPortalIndexRoute = AuthedPortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedPortalRoute,
} as any)
const AuthedOpsUsersRoute = AuthedOpsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedOpsTransactionsRoute = AuthedOpsTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedOpsRatesRoute = AuthedOpsRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedOpsParcelsRoute = AuthedOpsParcelsRouteImport.update({
  id: '/parcels',
  path: '/parcels',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedOpsMessagesRoute = AuthedOpsMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedOpsAddressesRoute = AuthedOpsAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedOpsAccountRoute = AuthedOpsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedOpsRoute,
} as any)
const AuthedPortalMessagesRoute = AuthedPortalMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthedPortalRoute,
} as any)
const AuthedPortalHistoryRoute = AuthedPortalHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthedPortalRoute,
} as any)
const AuthedPortalAddressesRoute = AuthedPortalAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AuthedPortalRoute,
} as any)
const AuthedPortalAccountRoute = AuthedPortalAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedPortalRoute,
} as any)
const AuthedPortalParcelIdRoute = AuthedPortalParcelIdRouteImport.update({
  id: '/parcel/$id',
  path: '/parcel/$id',
  getParentRoute: () => AuthedPortalRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedPortalIndexRoute
  '/onboarding': typeof AuthedOnboardingRoute
  '/ops': typeof AuthedOpsRouteWithChildren
  '/register': typeof AuthedRegisterRoute
  '/login': typeof PublicLoginRoute
  '/account': typeof AuthedPortalAccountRoute
  '/addresses': typeof AuthedPortalAddressesRoute
  '/history': typeof AuthedPortalHistoryRoute
  '/messages': typeof AuthedPortalMessagesRoute
  '/ops/account': typeof AuthedOpsAccountRoute
  '/ops/addresses': typeof AuthedOpsAddressesRoute
  '/ops/messages': typeof AuthedOpsMessagesRoute
  '/ops/parcels': typeof AuthedOpsParcelsRoute
  '/ops/rates': typeof AuthedOpsRatesRoute
  '/ops/transactions': typeof AuthedOpsTransactionsRoute
  '/ops/users': typeof AuthedOpsUsersRoute
  '/ops/': typeof AuthedOpsIndexRoute
  '/parcel/$id': typeof AuthedPortalParcelIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedPortalIndexRoute
  '/onboarding': typeof AuthedOnboardingRoute
  '/register': typeof AuthedRegisterRoute
  '/login': typeof PublicLoginRoute
  '/account': typeof AuthedPortalAccountRoute
  '/addresses': typeof AuthedPortalAddressesRoute
  '/history': typeof AuthedPortalHistoryRoute
  '/messages': typeof AuthedPortalMessagesRoute
  '/ops/account': typeof AuthedOpsAccountRoute
  '/ops/addresses': typeof AuthedOpsAddressesRoute
  '/ops/messages': typeof AuthedOpsMessagesRoute
  '/ops/parcels': typeof AuthedOpsParcelsRoute
  '/ops/rates': typeof AuthedOpsRatesRoute
  '/ops/transactions': typeof AuthedOpsTransactionsRoute
  '/ops/users': typeof AuthedOpsUsersRoute
  '/ops': typeof AuthedOpsIndexRoute
  '/parcel/$id': typeof AuthedPortalParcelIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/_portal': typeof AuthedPortalRouteWithChildren
  '/_authed/onboarding': typeof AuthedOnboardingRoute
  '/_authed/ops': typeof AuthedOpsRouteWithChildren
  '/_authed/register': typeof AuthedRegisterRoute
  '/_public/login': typeof PublicLoginRoute
  '/_authed/_portal/account': typeof AuthedPortalAccountRoute
  '/_authed/_portal/addresses': typeof AuthedPortalAddressesRoute
  '/_authed/_portal/history': typeof AuthedPortalHistoryRoute
  '/_authed/_portal/messages': typeof AuthedPortalMessagesRoute
  '/_authed/ops/account': typeof AuthedOpsAccountRoute
  '/_authed/ops/addresses': typeof AuthedOpsAddressesRoute
  '/_authed/ops/messages': typeof AuthedOpsMessagesRoute
  '/_authed/ops/parcels': typeof AuthedOpsParcelsRoute
  '/_authed/ops/rates': typeof AuthedOpsRatesRoute
  '/_authed/ops/transactions': typeof AuthedOpsTransactionsRoute
  '/_authed/ops/users': typeof AuthedOpsUsersRoute
  '/_authed/_portal/': typeof AuthedPortalIndexRoute
  '/_authed/ops/': typeof AuthedOpsIndexRoute
  '/_authed/_portal/parcel/$id': typeof AuthedPortalParcelIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/ops'
    | '/register'
    | '/login'
    | '/account'
    | '/addresses'
    | '/history'
    | '/messages'
    | '/ops/account'
    | '/ops/addresses'
    | '/ops/messages'
    | '/ops/parcels'
    | '/ops/rates'
    | '/ops/transactions'
    | '/ops/users'
    | '/ops/'
    | '/parcel/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/register'
    | '/login'
    | '/account'
    | '/addresses'
    | '/history'
    | '/messages'
    | '/ops/account'
    | '/ops/addresses'
    | '/ops/messages'
    | '/ops/parcels'
    | '/ops/rates'
    | '/ops/transactions'
    | '/ops/users'
    | '/ops'
    | '/parcel/$id'
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/_portal'
    | '/_authed/onboarding'
    | '/_authed/ops'
    | '/_authed/register'
    | '/_public/login'
    | '/_authed/_portal/account'
    | '/_authed/_portal/addresses'
    | '/_authed/_portal/history'
    | '/_authed/_portal/messages'
    | '/_authed/ops/account'
    | '/_authed/ops/addresses'
    | '/_authed/ops/messages'
    | '/_authed/ops/parcels'
    | '/_authed/ops/rates'
    | '/_authed/ops/transactions'
    | '/_authed/ops/users'
    | '/_authed/_portal/'
    | '/_authed/ops/'
    | '/_authed/_portal/parcel/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicLoginRoute: typeof PublicLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/register': {
      id: '/_authed/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthedRegisterRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ops': {
      id: '/_authed/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof AuthedOpsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/onboarding': {
      id: '/_authed/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthedOnboardingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_portal': {
      id: '/_authed/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedPortalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ops/': {
      id: '/_authed/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof AuthedOpsIndexRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/_portal/': {
      id: '/_authed/_portal/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedPortalIndexRouteImport
      parentRoute: typeof AuthedPortalRoute
    }
    '/_authed/ops/users': {
      id: '/_authed/ops/users'
      path: '/users'
      fullPath: '/ops/users'
      preLoaderRoute: typeof AuthedOpsUsersRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/ops/transactions': {
      id: '/_authed/ops/transactions'
      path: '/transactions'
      fullPath: '/ops/transactions'
      preLoaderRoute: typeof AuthedOpsTransactionsRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/ops/rates': {
      id: '/_authed/ops/rates'
      path: '/rates'
      fullPath: '/ops/rates'
      preLoaderRoute: typeof AuthedOpsRatesRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/ops/parcels': {
      id: '/_authed/ops/parcels'
      path: '/parcels'
      fullPath: '/ops/parcels'
      preLoaderRoute: typeof AuthedOpsParcelsRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/ops/messages': {
      id: '/_authed/ops/messages'
      path: '/messages'
      fullPath: '/ops/messages'
      preLoaderRoute: typeof AuthedOpsMessagesRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/ops/addresses': {
      id: '/_authed/ops/addresses'
      path: '/addresses'
      fullPath: '/ops/addresses'
      preLoaderRoute: typeof AuthedOpsAddressesRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/ops/account': {
      id: '/_authed/ops/account'
      path: '/account'
      fullPath: '/ops/account'
      preLoaderRoute: typeof AuthedOpsAccountRouteImport
      parentRoute: typeof AuthedOpsRoute
    }
    '/_authed/_portal/messages': {
      id: '/_authed/_portal/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthedPortalMessagesRouteImport
      parentRoute: typeof AuthedPortalRoute
    }
    '/_authed/_portal/history': {
      id: '/_authed/_portal/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AuthedPortalHistoryRouteImport
      parentRoute: typeof AuthedPortalRoute
    }
    '/_authed/_portal/addresses': {
      id: '/_authed/_portal/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AuthedPortalAddressesRouteImport
      parentRoute: typeof AuthedPortalRoute
    }
    '/_authed/_portal/account': {
      id: '/_authed/_portal/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedPortalAccountRouteImport
      parentRoute: typeof AuthedPortalRoute
    }
    '/_authed/_portal/parcel/$id': {
      id: '/_authed/_portal/parcel/$id'
      path: '/parcel/$id'
      fullPath: '/parcel/$id'
      preLoaderRoute: typeof AuthedPortalParcelIdRouteImport
      parentRoute: typeof AuthedPortalRoute
    }
  }
}

interface AuthedPortalRouteChildren {
  AuthedPortalAccountRoute: typeof AuthedPortalAccountRoute
  AuthedPortalAddressesRoute: typeof AuthedPortalAddressesRoute
  AuthedPortalHistoryRoute: typeof AuthedPortalHistoryRoute
  AuthedPortalMessagesRoute: typeof AuthedPortalMessagesRoute
  AuthedPortalIndexRoute: typeof AuthedPortalIndexRoute
  AuthedPortalParcelIdRoute: typeof AuthedPortalParcelIdRoute
}

const AuthedPortalRouteChildren: AuthedPortalRouteChildren = {
  AuthedPortalAccountRoute: AuthedPortalAccountRoute,
  AuthedPortalAddressesRoute: AuthedPortalAddressesRoute,
  AuthedPortalHistoryRoute: AuthedPortalHistoryRoute,
  AuthedPortalMessagesRoute: AuthedPortalMessagesRoute,
  AuthedPortalIndexRoute: AuthedPortalIndexRoute,
  AuthedPortalParcelIdRoute: AuthedPortalParcelIdRoute,
}

const AuthedPortalRouteWithChildren = AuthedPortalRoute._addFileChildren(
  AuthedPortalRouteChildren,
)

interface AuthedOpsRouteChildren {
  AuthedOpsAccountRoute: typeof AuthedOpsAccountRoute
  AuthedOpsAddressesRoute: typeof AuthedOpsAddressesRoute
  AuthedOpsMessagesRoute: typeof AuthedOpsMessagesRoute
  AuthedOpsParcelsRoute: typeof AuthedOpsParcelsRoute
  AuthedOpsRatesRoute: typeof AuthedOpsRatesRoute
  AuthedOpsTransactionsRoute: typeof AuthedOpsTransactionsRoute
  AuthedOpsUsersRoute: typeof AuthedOpsUsersRoute
  AuthedOpsIndexRoute: typeof AuthedOpsIndexRoute
}

const AuthedOpsRouteChildren: AuthedOpsRouteChildren = {
  AuthedOpsAccountRoute: AuthedOpsAccountRoute,
  AuthedOpsAddressesRoute: AuthedOpsAddressesRoute,
  AuthedOpsMessagesRoute: AuthedOpsMessagesRoute,
  AuthedOpsParcelsRoute: AuthedOpsParcelsRoute,
  AuthedOpsRatesRoute: AuthedOpsRatesRoute,
  AuthedOpsTransactionsRoute: AuthedOpsTransactionsRoute,
  AuthedOpsUsersRoute: AuthedOpsUsersRoute,
  AuthedOpsIndexRoute: AuthedOpsIndexRoute,
}

const AuthedOpsRouteWithChildren = AuthedOpsRoute._addFileChildren(
  AuthedOpsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedPortalRoute: typeof AuthedPortalRouteWithChildren
  AuthedOnboardingRoute: typeof AuthedOnboardingRoute
  AuthedOpsRoute: typeof AuthedOpsRouteWithChildren
  AuthedRegisterRoute: typeof AuthedRegisterRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedPortalRoute: AuthedPortalRouteWithChildren,
  AuthedOnboardingRoute: AuthedOnboardingRoute,
  AuthedOpsRoute: AuthedOpsRouteWithChildren,
  AuthedRegisterRoute: AuthedRegisterRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicLoginRoute: PublicLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
